import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
	Button,
	TextField
} from '@material-ui/core'
import { useHistory } from 'react-router-dom'
import { getConstants, updateConstants } from '../../../../api/constants'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'

function getEmptyConstants() {
  return {
    shippingPriceSpain: 5.0,
    shippingPriceEurope: 15.0,
    shippingPriceOutsideEurope: 0,
    generalDiscountPercent: 0,
    priceLimitRedsys: 0,
    redsysMerchantCode: '',
    redsysTerminal: '1',
    redsysSecretKey: '',
    redsysEnvironment: 'sandbox',
    redsysCurrency: '978',
    outlierQ1Percent: 25,
    outlierQ3Percent: 75,
    scraperCreditosPorDia: 563,
    scraperHora: '19:00',
    bankName: 'Banc Sabadell',
    bankAccountHolder: 'TURELOJYA, S.L',
    bankAccountNumber: '0081-0381-97-0001522159',
    bankIban: 'ES63 0081 0381 9700 0152 2159',
    bankSwift: 'BSAB ESBB',
    bankAddress: 'C/ Aribau 51, 08011 Barcelona, Spain',
    bankTelephone: '+34 630 332 709',
    telefonoTasacion: '',
  }
}

export default function EditConstantsPage() {
  const [constants, setConstants] = useState(getEmptyConstants())
  const history = useHistory()

  const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton()

  useEffect(() => {
    getConstants().then(res => {
      if (res.status === 200) {
        setConstants(res.data)
        disableLoadingData()
      }
    }).catch(error => {
      alertError({ error: error, customMessage: 'Could not get constants.' })
      disableLoadingData()
    })
  }, [disableLoadingData])

  function saveConstants() {
    updateConstants(constants).then(res => {
        if (res.status === 200) {
          alertSuccess({ title: 'Saved!', customMessage: 'Constants successfully saved.' })
        }
      }).catch(error => {
        alertError({ error: error, customMessage: 'Could not save constants.' })
      })
  }

  const handleChange = (field) => (event) => {
    const value = parseFloat(event.target.value) || 0
    setConstants({ ...constants, [field]: value })
  }

  const handleChangeText = (field) => (event) => {
    setConstants({ ...constants, [field]: event.target.value })
  }

  if (isLoadingData)
    return <ContentSkeleton />
  else return (
    <>
      <Card>
        <CardHeader title='Edit Constants'>
        </CardHeader>
        <CardBody>
        <h5 style={{ marginTop: '20px', marginBottom: '8px' }}>Precios</h5>
          <TextField
            id="priceLimitRedsys"
            label="Precio límite Redsys (€)"
            type="number"
            value={constants.priceLimitRedsys ?? 0}
            onChange={handleChange('priceLimitRedsys')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            fullWidth
            inputProps={{ min: 0, step: 0.01 }}
          />
          <TextField
            id="shippingPriceSpain"
            label="Precio Envío España (€)"
            type="number"
            value={constants.shippingPriceSpain || 0}
            onChange={handleChange('shippingPriceSpain')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            fullWidth
            inputProps={{ min: 0, step: 0.01 }}
          />
          <TextField
            id="shippingPriceEurope"
            label="Precio Envío Europa (€)"
            type="number"
            value={constants.shippingPriceEurope || 0}
            onChange={handleChange('shippingPriceEurope')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            fullWidth
            inputProps={{ min: 0, step: 0.01 }}
          />
          <TextField
            id="shippingPriceOutsideEurope"
            label="Precio Envío Fuera de Europa (€)"
            type="number"
            value={constants.shippingPriceOutsideEurope || 0}
            onChange={handleChange('shippingPriceOutsideEurope')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            fullWidth
            inputProps={{ min: 0, step: 0.01 }}
          />
          <h5 style={{ marginTop: '20px', marginBottom: '8px' }}>Tasación</h5>
          <TextField
            id="telefonoTasacion"
            label="Teléfono tasación (WhatsApp)"
            type="text"
            value={constants.telefonoTasacion || ''}
            onChange={handleChangeText('telefonoTasacion')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
            helperText="Teléfono que se muestra en el botón de WhatsApp de la página de tasación (pon solo dígitos, ej: 123456789)."
          />
          <TextField
            id="generalDiscountPercent"
            label="Descuento % General"
            type="number"
            value={constants.generalDiscountPercent || 0}
            onChange={handleChange('generalDiscountPercent')}
            InputLabelProps={{
              shrink: true
            }}
            margin="normal"
            variant="outlined"
            fullWidth
            inputProps={{ min: 0, max: 100, step: 0.01 }}
          />
                    <TextField
            id="outlierQ1Percent"
            label="Umbral inferior (%) para limpiar precios extremos"
            type="number"
            value={constants.outlierQ1Percent ?? 25}
            onChange={handleChange('outlierQ1Percent')}
            InputLabelProps={{
              shrink: true
            }}
            helperText="Porcentaje desde el que cortamos precios bajos (el % de relojes con precio mas bajo no se tendrá en cuenta para la tasación)."
            margin="normal"
            variant="outlined"
            fullWidth
            inputProps={{ min: 0, max: 100, step: 1 }}
          />
          <TextField
            id="outlierQ3Percent"
            label="Umbral superior (%) para limpiar precios extremos"
            type="number"
            value={constants.outlierQ3Percent ?? 75}
            onChange={handleChange('outlierQ3Percent')}
            InputLabelProps={{
              shrink: true
            }}
            helperText="Porcentaje desde el que cortamos precios altos (hasta este % de relojes se tendrán en cuenta para la tasación, los que tengan un precio mas alto no se tendrán en cuenta)."
            margin="normal"
            variant="outlined"
            fullWidth
            inputProps={{ min: 1, max: 100, step: 1 }}
          />

          <h5 style={{ marginTop: '20px', marginBottom: '8px' }}>Scraping</h5>
          <TextField
            id="scraperCreditosPorDia"
            label="Créditos diarios del scraping"
            type="number"
            value={constants.scraperCreditosPorDia ?? 563}
            onChange={handleChange('scraperCreditosPorDia')}
            InputLabelProps={{
              shrink: true
            }}
            helperText="Número de créditos que se usarán cada día para el scraping de relojes (por defecto: 563). Si es 0, el scraping no consumirá créditos."
            margin="normal"
            variant="outlined"
            fullWidth
            inputProps={{ min: 0, step: 1 }}
          />
          <TextField
            id="scraperHora"
            label="Hora del scraping (HH:MM)"
            type="time"
            value={constants.scraperHora ?? '19:00'}
            onChange={handleChangeText('scraperHora')}
            InputLabelProps={{
              shrink: true
            }}
            helperText="Hora a la que se ejecutará el scraping diariamente (formato 24 horas, por defecto: 19:00). El cron job se reiniciará automáticamente al guardar."
            margin="normal"
            variant="outlined"
            fullWidth
            inputProps={{ step: 60 }}
          />

          <h5 style={{ marginTop: '20px', marginBottom: '8px' }}>Redsys</h5>
          <TextField
            id="redsysMerchantCode"
            label="FUC (Merchant Code)"
            type="text"
            value={constants.redsysMerchantCode || ''}
            onChange={handleChangeText('redsysMerchantCode')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            id="redsysTerminal"
            label="Terminal"
            type="text"
            value={constants.redsysTerminal || ''}
            onChange={handleChangeText('redsysTerminal')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            id="redsysSecretKey"
            label="Clave secreta SHA256"
            type="password"
            value={constants.redsysSecretKey || ''}
            onChange={handleChangeText('redsysSecretKey')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
            helperText="Clave secreta del TPV proporcionada por Redsys (no se muestra)."
          />
          <TextField
            id="redsysEnvironment"
            label="Entorno (sandbox/production)"
            type="text"
            value={constants.redsysEnvironment || 'sandbox'}
            onChange={handleChangeText('redsysEnvironment')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
            helperText="Usa 'sandbox' para pruebas o 'production' para real."
          />
          <TextField
            id="redsysCurrency"
            label="Moneda (978=EUR)"
            type="text"
            value={constants.redsysCurrency || '978'}
            onChange={handleChangeText('redsysCurrency')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />


          <h5 style={{ marginTop: '20px', marginBottom: '8px' }}>Detalles de la cuenta bancaria</h5>
          <TextField
            id="bankName"
            label="Bank"
            value={constants.bankName || ''}
            onChange={handleChangeText('bankName')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            id="bankAccountHolder"
            label="Account holder"
            value={constants.bankAccountHolder || ''}
            onChange={handleChangeText('bankAccountHolder')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            id="bankAccountNumber"
            label="Account number"
            value={constants.bankAccountNumber || ''}
            onChange={handleChangeText('bankAccountNumber')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            id="bankIban"
            label="IBAN"
            value={constants.bankIban || ''}
            onChange={handleChangeText('bankIban')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            id="bankSwift"
            label="SWIFT / BIC"
            value={constants.bankSwift || ''}
            onChange={handleChangeText('bankSwift')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            id="bankAddress"
            label="Bank address"
            value={constants.bankAddress || ''}
            onChange={handleChangeText('bankAddress')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />
          <TextField
            id="bankTelephone"
            label="Telephone"
            value={constants.bankTelephone || ''}
            onChange={handleChangeText('bankTelephone')}
            InputLabelProps={{ shrink: true }}
            margin="normal"
            variant="outlined"
            fullWidth
          />
        </CardBody>
      </Card>
      <Button
        onClick={() => history.push('/dashboard')}
        variant="outlined"
        style={{ marginRight: '20px' }}>
        Back
      </Button>
      <Button
        onClick={() => saveConstants()}
        variant="outlined"
        color="primary"
        style={{ marginRight: '20px' }}>
        Save Constants
      </Button>
    </>
  );
}

